module.exports = __webpack_public_path__ + "img/paypal.bfa1152e.png";